// Amount number format fucntion
const AmountNumberFormat = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2, // Minimum number of digits after the decimal
        maximumFractionDigits: 2, // Maximum number of digits after the decimal
    }).format(amount);
};

export default AmountNumberFormat;